export default __webpack_public_path__ + "static/media/mooncat-world.f27deecd.jpg";